/**
 * Detecção e utilidades do empacotamento Neutralino (versão desktop).
 *
 * No navegador nada disso existe e todas as funções degradam para no-op, de modo
 * que o mesmo bundle roda nos dois lugares sem ramificação no chamador.
 *
 * O Neutralino injeta os globais NL_* e a lib cliente (neutralino.js) antes do
 * bundle da aplicação — por isso a checagem é síncrona e pode ser usada já na
 * carga do módulo (o useTheme depende disso para evitar FOUC).
 */

export const isDesktop = () =>
  typeof window !== 'undefined' && typeof window.NL_VERSION !== 'undefined';

/** Versão do runtime Neutralino, ou null no navegador. */
export const desktopVersion = () => (isDesktop() ? window.NL_VERSION : null);

/** Versão da aplicação declarada em neutralino.config.json. */
export const appVersion = () => (isDesktop() ? window.NL_APPVERSION : null);

/** 'Windows' | 'Darwin' | 'Linux' | null */
export const desktopOS = () => (isDesktop() ? window.NL_OS : null);

/**
 * Inicializa a ponte nativa. Idempotente: chamar mais de uma vez é seguro,
 * porque o Neutralino ignora init() repetido.
 */
export const initDesktop = () => {
  if (!isDesktop() || !window.Neutralino) return false;
  try {
    window.Neutralino.init();
    // Fechar a janela nativa encerra o processo — sem isso o app fica órfão
    // rodando em background quando o usuário clica no X.
    window.Neutralino.events.on('windowClose', () => {
      window.Neutralino.app.exit();
    });
    return true;
  } catch (e) {
    console.error('Falha ao inicializar a ponte Neutralino:', e);
    return false;
  }
};
